import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {OrderSummaryDataHook} from '../OrderSummary';
import commonStyles from '../OrderSummary.scss';
import s from './CouponTotal.scss';
import classnames from 'classnames';

export const CouponTotal = () => {
  const {t} = useTranslation();
  const {cartModel, estimatedTotals} = useControllerProps().cartStore;
  const appliedCoupon = estimatedTotals?.appliedCoupon || cartModel.appliedCoupon;
  const couponAmount =
    estimatedTotals?.priceSummary?.discount.formattedConvertedAmount ?? cartModel.discount.formattedConvertedAmount;

  return (
    <div data-hook={OrderSummaryDataHook.CouponRoot} className={classnames(commonStyles.divider, s.root)}>
      <dl>
        <dt>
          <span data-hook={OrderSummaryDataHook.CouponLabel}>{t('cart.coupon')}</span>{' '}
          <span data-hook={OrderSummaryDataHook.CouponCode}>{appliedCoupon.code}</span>
        </dt>
        <dd
          className={s.value}
          data-hook={OrderSummaryDataHook.CouponDiscountValue}
          data-wix-coupon-discount-value={OrderSummaryDataHook.CouponDiscountValue}>
          -{couponAmount}
        </dd>
      </dl>
    </div>
  );
};
